import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import { Alert } from "reactstrap";
import Select from "react-select";
import { getcitylist } from "store/participantcity/actions";
import { getdistrictlist } from "store/participantdistrict/actions";
import { getprovincelist } from "store/participantprovince/actions";
import { getdesignationlist } from "store/participantdesignation/actions";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Button,
  Input,
} from "reactstrap";
import {
  getApprovedLabs,
  updateMembershipStatus,
} from "store/registration-admin/actions";
import { getParticipantSchemelist } from "store/Payment/actions";
import { getcyclelist } from "store/cycle/actions";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "components/Common/Breadcrumb";
import {
  getAllLabs,
  updateAllLabs,
} from "store/registration-admin/actions";

class AllParticipantsEditPage extends Component {
  constructor(props) {
    super(props);

    // Get participant data from route params or location state
    const participantId = this.props.match.params.id;
    const participant = this.props.location.state?.participant || {};

    this.state = {
      // Participant data
      participantId,
      id: participant.id || "",
      name: participant.name || "",
      email: participant.email || "",
      address: participant.address || "",
      district: participant.district || "",
      city: participant.city || "",
      province: participant.province || "",
      shipping_address: participant.shipping_address || "",
      billing_address: participant.billing_address || "",
      lab_staff_name: participant.lab_staff_name || "",
      email_participant: participant.email_participant || "",
      landline_registered_by: participant.landline_registered_by || "",
      designation: participant.lab_staff_designation || participant.designation || "",
      payment_status: participant.payment_status || "",
      payment_settlement: participant.payment_settlement || "",

      // Dropdown options
      ListCity: [],
      ListDistrict: [],
      ListProvince: [],
      ListDesignation: [],

      // UI State
      successMessage: "",
      errorMessage: "",
      organization_name: "",
      loading: true,
      isSubmitting: false,
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
    };

    this.handleEditSubmit = this.handleEditSubmit.bind(this);
  }

  componentDidMount() {
    console.log("Edit page mounted for participant:", this.state.participantId);
    
    const authUser = localStorage.getItem("authUser");
    const user_id = authUser ? JSON.parse(authUser).user_id : null;

   

    // Get organization name from URL params
    const { organization_name } = this.props.match.params || {};
    if (!organization_name) {
      console.error("Organization name is missing in URL parameters.");
      this.props.history.goBack();
      return;
    }

    this.setState({ organization_name, user_id }, () => {
      this.fetchData(user_id);
      this.loadParticipantData();
    });
  }

  fetchData(user_id) {
    const {
      onGetCityList,
      onGetDistrictList,
      onGetProvinceList,
      onGetdesignationlist,
      onGetPendingLabs,
    } = this.props;

    // Fetch dropdown data
    onGetCityList(user_id);
    onGetDistrictList(user_id);
    onGetProvinceList(user_id);
    onGetdesignationlist(user_id);
    
    // Fetch all labs to get participant data if not provided
    onGetPendingLabs(user_id);
  }

  loadParticipantData() {
    // If participant data wasn't passed via location.state, 
    // we'll need to fetch it from AllLabs when it's available
    if (!this.state.id && this.state.participantId && this.props.AllLabs.length > 0) {
      const participant = this.props.AllLabs.find(p => p.id == this.state.participantId);
      
      if (participant) {
        this.setState({
          id: participant.id || "",
          name: participant.name || "",
          email: participant.email || "",
          address: participant.address || "",
          district: participant.district || "",
          city: participant.city || "",
          province: participant.province || "",
          shipping_address: participant.shipping_address || "",
          billing_address: participant.billing_address || "",
          lab_staff_name: participant.lab_staff_name || "",
          email_participant: participant.email_participant || "",
          landline_registered_by: participant.landline_registered_by || "",
          designation: participant.lab_staff_designation || participant.designation || "",
          payment_status: participant.payment_status || "",
          payment_settlement: participant.payment_settlement || "",
          loading: false,
        });
      } else {
        this.setState({
          errorMessage: `Participant with ID ${this.state.participantId} not found.`,
          loading: false
        });
      }
    } else if (this.state.id) {
      // Data already loaded from location.state
      this.setState({ loading: false });
    }
  }

  componentDidUpdate(prevProps) {
    // Update dropdown options when they're loaded
    if (prevProps.ListCity !== this.props.ListCity) {
      this.setState({ ListCity: this.props.ListCity });
    }
    if (prevProps.ListDistrict !== this.props.ListDistrict) {
      this.setState({ ListDistrict: this.props.ListDistrict });
    }
    if (prevProps.ListProvince !== this.props.ListProvince) {
      this.setState({ ListProvince: this.props.ListProvince });
    }
    if (prevProps.ListDesignation !== this.props.ListDesignation) {
      this.setState({ ListDesignation: this.props.ListDesignation });
    }

    // Load participant data when AllLabs is populated
    if (prevProps.AllLabs !== this.props.AllLabs && this.props.AllLabs.length > 0) {
      if (!this.state.id && this.state.loading) {
        this.loadParticipantData();
      }
    }
  }

  async handleEditSubmit(values, { setSubmitting }) {
  console.log("Form values:", values);

  this.setState({ isSubmitting: true, errorMessage: "", successMessage: "" });

  const updatedData = {
    id: parseInt(this.state.id),
    name: values.name,
    email: values.email,
    address: values.address,
    province: values.province,
    designation: values.designation,
    shipping_address: values.shipping_address,
    billing_address: values.billing_address,
    marketer_name: values.marketer_name || "",
    city: values.city,
    district: values.district,
    lab_staff_name: values.lab_staff_name,
    email_participant: values.email_participant,
    landline_registered_by: values.landline_registered_by,
    payment_status: values.payment_status,
    payment_settlement: values.payment_settlement,
  };

  try {
    console.log("Updating participant with data:", updatedData);

    // Call the update action
    await this.props.onupdateAllLabs(updatedData);

    this.setState({ successMessage: "Participant updated successfully" }, () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // Refresh list after 1s
    setTimeout(() => {
      const currentAuth = localStorage.getItem("authUser");
      const currentUserId = currentAuth ? JSON.parse(currentAuth).user_id : null;

     
      this.props.ongetApprovedLabs(currentUserId);
    }, 1000);

    // Redirect back after 2s
    setTimeout(() => {
      const currentAuth = localStorage.getItem("authUser");
      const currentUserId = currentAuth ? JSON.parse(currentAuth).user_id : null;

     
      this.setState({ successMessage: "" }, () => {
        this.props.history.push(`/${this.state.organization_name}/all-participant`);
      });
    }, 2000);

  } catch (error) {
    console.error("Failed to update participant:", error);
    this.setState({ 
      errorMessage: "Failed to update participant. Please try again.",
      isSubmitting: false
    });
  }

  setSubmitting(false);
}
 

  render() {
    const {
      ListCity,
      ListDistrict,
      ListProvince,
      ListDesignation,
      successMessage,
      errorMessage,
      loading,
      isSubmitting,
    } = this.state;

    if (loading) {
      return (
        <div className="page-content" style={{ padding: "50px", textAlign: "center" }}>
          <h4>Loading participant data...</h4>
        </div>
      );
    }

    // Use state data or props data as fallback
    const cityOptions = (ListCity.length ? ListCity : this.props.ListCity || []).map(city => ({
      value: city.name,
      label: city.name,
    }));
    const districtOptions = (ListDistrict.length ? ListDistrict : this.props.ListDistrict || []).map(district => ({
      value: district.name,
      label: district.name,
    }));
    const provinceOptions = (ListProvince.length ? ListProvince : this.props.ListProvince || []).map(province => ({
      value: province.name,
      label: province.name,
    }));
    const designationOptions = (ListDesignation.length ? ListDesignation : this.props.ListDesignation || []).map(designation => ({
      value: designation.name,
      label: designation.name,
    }));

    const customStyles = {
      control: provided => ({
        ...provided,
        minHeight: "38px",
      }),
    };

    // Validation schema
    const validationSchema = Yup.object().shape({
      name: Yup.string().required("Name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      address: Yup.string().required("Address is required"),
    });

    return (
      <React.Fragment>
        <div className="page-content" style={{ width: "80%", margin: "100px auto" }}>
          <MetaTags>
            <title>Edit Participant | Lab Management System</title>
          </MetaTags>
          <Container fluid>
            {/* Breadcrumb */}
            <Breadcrumbs 
              title="Participants" 
              breadcrumbItem="Edit Participant" 
            />

            {/* Success Message */}
            {successMessage && (
              <Row className="mb-4">
                <Col>
                  <Alert color="success" className="text-center" style={{ fontWeight: "bold" }}>
                    {successMessage}
                  </Alert>
                </Col>
              </Row>
            )}

            {/* Error Message */}
            {errorMessage && (
              <Row className="mb-4">
                <Col>
                  <Alert color="danger" className="text-center" style={{ fontWeight: "bold" }}>
                    {errorMessage}
                  </Alert>
                </Col>
              </Row>
            )}

            {/* Main Form Card */}
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    

                    <Formik
                      enableReinitialize
                      initialValues={{
                        id: this.state.id,
                        name: this.state.name,
                        email: this.state.email,
                        address: this.state.address,
                        district: this.state.district,
                        city: this.state.city,
                        province: this.state.province,
                        shipping_address: this.state.shipping_address,
                        billing_address: this.state.billing_address,
                        lab_staff_name: this.state.lab_staff_name,
                        email_participant: this.state.email_participant,
                        landline_registered_by: this.state.landline_registered_by,
                        designation: this.state.designation,
                        payment_status: this.state.payment_status,
                        payment_settlement: this.state.payment_settlement,
                      }}
                      validationSchema={validationSchema}
                      onSubmit={this.handleEditSubmit}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        setFieldValue,
                        handleChange,
                        handleSubmit,
                        isSubmitting: formikSubmitting,
                      }) => (
                        <Form onSubmit={handleSubmit}>
                          <Row>
                            <Col className="col-12">
                              {/* Name Field */}
                              <div className="mb-3">
                                <Label className="form-label">Name *</Label>
                                <Input
                                  type="text"
                                  name="name"
                                  className={`form-control ${errors.name && touched.name ? 'is-invalid' : ''}`}
                                  placeholder="Enter Name"
                                  value={values.name}
                                  onChange={handleChange}
                                />
                                {errors.name && touched.name && (
                                  <div className="invalid-feedback">{errors.name}</div>
                                )}
                              </div>

                              {/* Email Field */}
                              <div className="mb-3">
                                <Label className="form-label">Login Email *</Label>
                                <Input
                                  type="email"
                                  name="email"
                                  className={`form-control ${errors.email && touched.email ? 'is-invalid' : ''}`}
                                  placeholder="Enter Email"
                                  value={values.email}
                                  onChange={handleChange}
                                  style={{ backgroundColor: "#f8f9fa" }}
                                />
                                {errors.email && touched.email && (
                                  <div className="invalid-feedback">{errors.email}</div>
                                )}
                              </div>

                              {/* Address Field */}
                              <div className="mb-3">
                                <Label className="form-label">Address *</Label>
                                <Input
                                  type="text"
                                  name="address"
                                  className={`form-control ${errors.address && touched.address ? 'is-invalid' : ''}`}
                                  placeholder="Enter Address"
                                  value={values.address}
                                  onChange={handleChange}
                                />
                                {errors.address && touched.address && (
                                  <div className="invalid-feedback">{errors.address}</div>
                                )}
                              </div>

                              {/* Shipping and Billing Address */}
                              <Row>
                                <Col md={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Shipping Address</Label>
                                    <Input
                                      type="text"
                                      name="shipping_address"
                                      className="form-control"
                                      placeholder="Enter Shipping Address"
                                      value={values.shipping_address}
                                      onChange={handleChange}
                                    />
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Billing Address</Label>
                                    <Input
                                      type="text"
                                      name="billing_address"
                                      className="form-control"
                                      placeholder="Enter Billing Address"
                                      value={values.billing_address}
                                      onChange={handleChange}
                                    />
                                  </div>
                                </Col>
                              </Row>

                              {/* District, City, Province */}
                              <Row>
                                <Col sm={6} md={4}>
                                  <div className="mb-3">
                                    <Label className="form-label">District</Label>
                                    <Select
                                      name="district"
                                      options={districtOptions}
                                      styles={customStyles}
                                      className={errors.district && touched.district ? "is-invalid" : ""}
                                      onChange={selectedOption => {
                                        setFieldValue(
                                          "district",
                                          selectedOption ? selectedOption.value : ""
                                        );
                                      }}
                                      value={
                                        districtOptions.find(
                                          option => option.value === values.district
                                        ) || null
                                      }
                                      placeholder="Select District"
                                    />
                                    <ErrorMessage
                                      name="district"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </Col>

                                <Col sm={6} md={4}>
                                  <div className="mb-3">
                                    <Label className="form-label">City</Label>
                                    <Select
                                      name="city"
                                      options={cityOptions}
                                      styles={customStyles}
                                      className={errors.city && touched.city ? "is-invalid" : ""}
                                      onChange={selectedOption => {
                                        setFieldValue(
                                          "city",
                                          selectedOption ? selectedOption.value : ""
                                        );
                                      }}
                                      value={
                                        cityOptions.find(
                                          option => option.value === values.city
                                        ) || null
                                      }
                                      placeholder="Select City"
                                    />
                                    <ErrorMessage
                                      name="city"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </Col>

                                <Col sm={6} md={4}>
                                  <div className="mb-3">
                                    <Label className="form-label">Province</Label>
                                    <Select
                                      name="province"
                                      options={provinceOptions}
                                      styles={customStyles}
                                      className={errors.province && touched.province ? "is-invalid" : ""}
                                      onChange={selectedOption => {
                                        setFieldValue(
                                          "province",
                                          selectedOption ? selectedOption.value : ""
                                        );
                                      }}
                                      value={
                                        provinceOptions.find(
                                          option => option.value === values.province
                                        ) || null
                                      }
                                      placeholder="Select Province"
                                    />
                                    <ErrorMessage
                                      name="province"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </Col>
                              </Row>

                              {/* Notification Person Details Section */}
                              <div className="mt-4 mb-3">
                                <h5>Notification Person Details</h5>
                              </div>

                              <Row>
                                <Col md={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Email</Label>
                                    <Input
                                      type="email"
                                      name="email_participant"
                                      className="form-control"
                                      placeholder="Enter Email"
                                      value={values.email_participant}
                                      onChange={handleChange}
                                    />
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Name</Label>
                                    <Input
                                      type="text"
                                      name="lab_staff_name"
                                      className="form-control"
                                      placeholder="Enter Name"
                                      value={values.lab_staff_name}
                                      onChange={handleChange}
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col md={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Contact No</Label>
                                    <Input
                                      type="text"
                                      name="landline_registered_by"
                                      className="form-control"
                                      placeholder="Enter Contact No"
                                      value={values.landline_registered_by}
                                      onChange={handleChange}
                                    />
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <div className="mb-3">
                                    <Label className="form-label">Designation</Label>
                                    <Select
                                      name="designation"
                                      options={designationOptions}
                                      styles={customStyles}
                                      className={errors.designation && touched.designation ? "is-invalid" : ""}
                                      onChange={selectedOption => {
                                        setFieldValue(
                                          "designation",
                                          selectedOption ? selectedOption.value : ""
                                        );
                                      }}
                                      value={
                                        designationOptions.find(
                                          option => option.value === values.designation
                                        ) || null
                                      }
                                      placeholder="Select Designation"
                                    />
                                    <ErrorMessage
                                      name="designation"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </Col>
                              </Row>

                              {/* Action Buttons */}
                              <div className="mt-4 text-end">
                                <Button
                                  type="submit"
                                  color="primary"
                                  className="me-2"
                                  disabled={formikSubmitting || isSubmitting}
                                >
                                  {(formikSubmitting || isSubmitting) ? "Saving..." : "Save Changes"}
                                </Button>
                                <Button
                                  type="button"
                                  color="secondary"
                                  onClick={this.goBack}
                                  disabled={formikSubmitting || isSubmitting}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

AllParticipantsEditPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
      organization_name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,

  // Redux Props
  AllLabs: PropTypes.array,
  ListCity: PropTypes.array,
  ListDistrict: PropTypes.array,
  ListProvince: PropTypes.array,
  ListDesignation: PropTypes.array,

  // Redux Dispatchers
  onGetCityList: PropTypes.func.isRequired,
  onGetDistrictList: PropTypes.func.isRequired,
  onGetProvinceList: PropTypes.func.isRequired,
  onGetdesignationlist: PropTypes.func.isRequired,
  onupdateAllLabs: PropTypes.func.isRequired,
  ongetApprovedLabs: PropTypes.func.isRequired,
  onGetPendingLabs: PropTypes.func.isRequired,
};

const mapStateToProps = ({
  Account,
  ListCity,
  ListDistrict,
  ListDesignation,
  ListProvince,
  registrationAdmin,
}) => {
  return {
    userID: Account?.userID || null,
    ListCity: ListCity?.ListCity || [],
    ListDistrict: ListDistrict?.ListDistrict || [],
    ListProvince: ListProvince?.ListProvince || [],
    ListDesignation: ListDesignation?.ListDesignation || [],
    AllLabs: registrationAdmin?.AllLabs || [],
  };
};

const mapDispatchToProps = {
  onGetCityList: getcitylist,
  onGetDistrictList: getdistrictlist,
  onGetProvinceList: getprovincelist,
  onGetdesignationlist: getdesignationlist,
  onupdateAllLabs: updateAllLabs,
  ongetApprovedLabs: getApprovedLabs,
  onGetPendingLabs: getAllLabs,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AllParticipantsEditPage));